import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import store from '@/store';
import { IFile } from '../dto/FileUpload';

@Module({ dynamic: true, store, name: 'fileUpload', namespaced: true })
class FileUpload extends VuexModule implements IFile {

    // state
    /**
     * @state
     * ファイルデータ1
     * ファイル情報を格納する
     */
    uploadFile1: any = [];

    /**
     * @state
     * ファイルデータ2
     * ファイル情報を格納する
     */
    uploadFile2: any = [];

    /**
     * @state
     * ファイルデータ3
     * ファイル情報を格納する
     */
    uploadFile3: any = [];

    /**
     * @state
     * ファイルデータ4
     * ファイル情報を格納する
     */
    uploadFile4: any = [];

    /**
     * @state
     * ファイルデータ5
     * ファイル情報を格納する
     */
    uploadFile5: any = [];

    /**
     * @state
     * ファイルデータ6
     * ファイル情報を格納する
     */
    uploadFile6: any = [];

    /**
     * @state
     * ファイルデータ7
     * ファイル情報を格納する
     */
    uploadFile7: any = [];

    /**
     * @state
     * ファイルデータ8
     * ファイル情報を格納する
     */
    uploadFile8: any = [];

    /**
     * @state
     * ファイルデータ9
     * ファイル情報を格納する
     */
    uploadFile9: any = [];

    /**
     * @state
     * ファイルデータ10
     * ファイル情報を格納する
     */
    uploadFile10: any = [];

    /**
     * @state
     * ファイルデータ11
     * ファイル情報を格納する
     */
    uploadFile11: any = [];

    /**
     * @state
     * ファイルデータ12
     * ファイル情報を格納する
     */
    uploadFile12: any = [];

    /**
     * @state
     * ファイルデータ13
     * ファイル情報を格納する
     */
    uploadFile13: any = [];

    /**
     * @state
     * ファイルデータ14
     * ファイル情報を格納する
     */
    uploadFile14: any = [];

    /**
     * @state
     * ファイルデータ15
     * ファイル情報を格納する
     */
    uploadFile15: any = [];

    /**
     * @state
     * ファイルデータ16
     * ファイル情報を格納する
     */
    uploadFile16: any = [];

    /**
     * @state
     * ファイルデータ17
     * ファイル情報を格納する
     */
    uploadFile17: any = [];

    /**
     * @state
     * ファイルデータ18
     * ファイル情報を格納する
     */
    uploadFile18: any = [];

    /**
     * @state
     * ファイルデータ19
     * ファイル情報を格納する
     */
    uploadFile19: any = [];

    /**
     * @state
     * ファイルデータ20
     * ファイル情報を格納する
     */
    uploadFile20: any = [];

    // 2022.02.16 jinno 添付ファイル追加対応 start
    /**
     * @state
     * ファイルデータ21
     * ファイル情報を格納する
     */
    uploadFile21: any = [];

    /**
     * @state
     * ファイルデータ22
     * ファイル情報を格納する
     */
    uploadFile22: any = [];

    /**
     * @state
     * ファイルデータ23
     * ファイル情報を格納する
     */
    uploadFile23: any = [];

    /**
     * @state
     * ファイルデータ24
     * ファイル情報を格納する
     */
    uploadFile24: any = [];

    /**
     * @state
     * ファイルデータ25
     * ファイル情報を格納する
     */
    uploadFile25: any = [];

    /**
     * @state
     * ファイルデータ26
     * ファイル情報を格納する
     */
    uploadFile26: any = [];
    /**
     * @state
     * ファイルデータ27
     * ファイル情報を格納する
     */
    uploadFile27: any = [];

    /**
     * @state
     * ファイルデータ28
     * ファイル情報を格納する
     */
    uploadFile28: any = [];

    /**
     * @state
     * ファイルデータ29
     * ファイル情報を格納する
     */
    uploadFile29: any = [];

    /**
     * @state
     * ファイルデータ30
     * ファイル情報を格納する
     */
    uploadFile30: any = [];

    // 2022.02.16 jinno 添付ファイル追加対応 end
    /**
     * @state
     * コード番号1
     * コード番号情報を格納する
     */
    codeNo1: string = '';

    /**
     * @state
     * コード番号2
     * コード番号情報を格納する
     */
    codeNo2: string = '';

    /**
     * @state
     * コード番号3
     * コード番号情報を格納する
     */
    codeNo3: string = '';

    /**
     * @state
     * コード番号4
     * コード番号情報を格納する
     */
    codeNo4: string = '';

    /**
     * @state
     * コード番号5
     * コード番号情報を格納する
     */
    codeNo5: string = '';

    /**
     * @state
     * コード番号6
     * コード番号情報を格納する
     */
    codeNo6: string = '';

    /**
     * @state
     * コード番号7
     * コード番号情報を格納する
     */
    codeNo7: string = '';

    /**
     * @state
     * コード番号8
     * コード番号情報を格納する
     */
    codeNo8: string = '';

    /**
     * @state
     * コード番号9
     * コード番号情報を格納する
     */
    codeNo9: string = '';

    /**
     * @state
     * コード番号10
     * コード番号情報を格納する
     */
    codeNo10: string = '';

    /**
     * @state
     * コード番号11
     * コード番号情報を格納する
     */
    codeNo11: string = '';

    /**
     * @state
     * コード番号12
     * コード番号情報を格納する
     */
    codeNo12: string = '';

    /**
     * @state
     * コード番号13
     * コード番号情報を格納する
     */
    codeNo13: string = '';

    /**
     * @state
     * コード番号14
     * コード番号情報を格納する
     */
    codeNo14: string = '';

    /**
     * @state
     * コード番号15
     * コード番号情報を格納する
     */
    codeNo15: string = '';

    /**
     * @state
     * コード番号16
     * コード番号情報を格納する
     */
    codeNo16: string = '';

    /**
     * @state
     * コード番号17
     * コード番号情報を格納する
     */
    codeNo17: string = '';

    /**
     * @state
     * コード番号18
     * コード番号情報を格納する
     */
    codeNo18: string = '';

    /**
     * @state
     * コード番号19
     * コード番号情報を格納する
     */
    codeNo19: string = '';

    /**
     * @state
     * コード番号20
     * コード番号情報を格納する
     */
    codeNo20: string = '';

    // 2022.02.16 jinno 添付ファイル追加対応 start
    /**
     * @state
     * コード番号21
     * コード番号情報を格納する
     */
    codeNo21: string = '';

    /**
     * @state
     * コード番号22
     * コード番号情報を格納する
     */
    codeNo22: string = '';

    /**
     * @state
     * コード番号23
     * コード番号情報を格納する
     */
    codeNo23: string = '';

    /**
     * @state
     * コード番号24
     * コード番号情報を格納する
     */
    codeNo24: string = '';

    /**
     * @state
     * コード番号25
     * コード番号情報を格納する
     */
    codeNo25: string = '';

    /**
     * @state
     * コード番号26
     * コード番号情報を格納する
     */
    codeNo26: string = '';

    /**
     * @state
     * コード番号27
     * コード番号情報を格納する
     */
    codeNo27: string = '';

    /**
     * @state
     * コード番号28
     * コード番号情報を格納する
     */
    codeNo28: string = '';

    /**
     * @state
     * コード番号29
     * コード番号情報を格納する
     */
    codeNo29: string = '';

    /**
     * @state
     * コード番号30
     * コード番号情報を格納する
     */
    codeNo30: string = '';
    // 2022.02.16 jinno 添付ファイル追加対応 end
    // getter
    /**
     * @Getter
     * uploadFile1の取得
     */
    get GET_UPLOAD_FILE1() {
        return this.uploadFile1;
    }

    /**
     * @Getter
     * uploadFile2の取得
     */
    get GET_UPLOAD_FILE2() {
        return this.uploadFile2;
    }

    /**
     * @Getter
     * uploadFile3の取得
     */
    get GET_UPLOAD_FILE3() {
        return this.uploadFile3;
    }

    /**
     * @Getter
     * uploadFile4の取得
     */
    get GET_UPLOAD_FILE4() {
        return this.uploadFile4;
    }

    /**
     * @Getter
     * uploadFile5の取得
     */
    get GET_UPLOAD_FILE5() {
        return this.uploadFile5;
    }

    /**
     * @Getter
     * uploadFile6の取得
     */
    get GET_UPLOAD_FILE6() {
        return this.uploadFile6;
    }

    /**
     * @Getter
     * uploadFile7の取得
     */
    get GET_UPLOAD_FILE7() {
        return this.uploadFile7;
    }

    /**
     * @Getter
     * uploadFile8の取得
     */
    get GET_UPLOAD_FILE8() {
        return this.uploadFile8;
    }

    /**
     * @Getter
     * uploadFile9の取得
     */
    get GET_UPLOAD_FILE9() {
        return this.uploadFile9;
    }

    /**
     * @Getter
     * uploadFile10の取得
     */
    get GET_UPLOAD_FILE10() {
        return this.uploadFile10;
    }

    /**
     * @Getter
     * uploadFile11の取得
     */
    get GET_UPLOAD_FILE11() {
        return this.uploadFile11;
    }

    /**
     * @Getter
     * uploadFile12の取得
     */
    get GET_UPLOAD_FILE12() {
        return this.uploadFile12;
    }

    /**
     * @Getter
     * uploadFile13の取得
     */
    get GET_UPLOAD_FILE13() {
        return this.uploadFile13;
    }

    /**
     * @Getter
     * uploadFile14の取得
     */
    get GET_UPLOAD_FILE14() {
        return this.uploadFile14;
    }

    /**
     * @Getter
     * uploadFile15の取得
     */
    get GET_UPLOAD_FILE15() {
        return this.uploadFile15;
    }

    /**
     * @Getter
     * uploadFile16の取得
     */
    get GET_UPLOAD_FILE16() {
        return this.uploadFile16;
    }

    /**
     * @Getter
     * uploadFile17の取得
     */
    get GET_UPLOAD_FILE17() {
        return this.uploadFile17;
    }

    /**
     * @Getter
     * uploadFile18の取得
     */
    get GET_UPLOAD_FILE18() {
        return this.uploadFile18;
    }

    /**
     * @Getter
     * uploadFile19の取得
     */
    get GET_UPLOAD_FILE19() {
        return this.uploadFile19;
    }

    /**
     * @Getter
     * uploadFile20の取得
     */
    get GET_UPLOAD_FILE20() {
        return this.uploadFile20;
    }

    // 2022.02.16 jinno 添付ファイル追加対応 start
    /**
     * @Getter
     * uploadFile21の取得
     */
     get GET_UPLOAD_FILE21() {
        return this.uploadFile21;
    }

    /**
     * @Getter
     * uploadFile22の取得
     */
    get GET_UPLOAD_FILE22() {
        return this.uploadFile22;
    }

    /**
     * @Getter
     * uploadFile23の取得
     */
    get GET_UPLOAD_FILE23() {
        return this.uploadFile23;
    }

    /**
     * @Getter
     * uploadFile24の取得
     */
    get GET_UPLOAD_FILE24() {
        return this.uploadFile24;
    }

    /**
     * @Getter
     * uploadFile25の取得
     */
    get GET_UPLOAD_FILE25() {
        return this.uploadFile25;
    }

    /**
     * @Getter
     * uploadFile26の取得
     */
    get GET_UPLOAD_FILE26() {
        return this.uploadFile26;
    }

    /**
     * @Getter
     * uploadFile27の取得
     */
    get GET_UPLOAD_FILE27() {
        return this.uploadFile27;
    }

    /**
     * @Getter
     * uploadFile28の取得
     */
    get GET_UPLOAD_FILE28() {
        return this.uploadFile28;
    }

    /**
     * @Getter
     * uploadFile29の取得
     */
    get GET_UPLOAD_FILE29() {
        return this.uploadFile29;
    }

    /**
     * @Getter
     * uploadFile30の取得
     */
    get GET_UPLOAD_FILE30() {
        return this.uploadFile30;
    }
    // 2022.02.16 jinno 添付ファイル追加対応 end

    /**
     * @Getter
     * codeNo1の取得
     */
    get GET_CODE_NO1() {
        return this.codeNo1;
    }

    /**
     * @Getter
     * codeNo2の取得
     */
    get GET_CODE_NO2() {
        return this.codeNo2;
    }

    /**
     * @Getter
     * codeNo3の取得
     */
    get GET_CODE_NO3() {
        return this.codeNo3;
    }

    /**
     * @Getter
     * codeNo4の取得
     */
    get GET_CODE_NO4() {
        return this.codeNo4;
    }

    /**
     * @Getter
     * codeNo5の取得
     */
    get GET_CODE_NO5() {
        return this.codeNo5;
    }

    /**
     * @Getter
     * codeNo6の取得
     */
    get GET_CODE_NO6() {
        return this.codeNo6;
    }

    /**
     * @Getter
     * codeNo7の取得
     */
    get GET_CODE_NO7() {
        return this.codeNo7;
    }

    /**
     * @Getter
     * codeNo8の取得
     */
    get GET_CODE_NO8() {
        return this.codeNo8;
    }

    /**
     * @Getter
     * codeNo9の取得
     */
    get GET_CODE_NO9() {
        return this.codeNo9;
    }

    /**
     * @Getter
     * codeNo10の取得
     */
    get GET_CODE_NO10() {
        return this.codeNo10;
    }

    /**
     * @Getter
     * codeNo11の取得
     */
    get GET_CODE_NO11() {
        return this.codeNo11;
    }

    /**
     * @Getter
     * codeNo12の取得
     */
    get GET_CODE_NO12() {
        return this.codeNo12;
    }

    /**
     * @Getter
     * codeNo13の取得
     */
    get GET_CODE_NO13() {
        return this.codeNo13;
    }

    /**
     * @Getter
     * codeNo14の取得
     */
    get GET_CODE_NO14() {
        return this.codeNo14;
    }

    /**
     * @Getter
     * codeNo15の取得
     */
    get GET_CODE_NO15() {
        return this.codeNo15;
    }

    /**
     * @Getter
     * codeNo16の取得
     */
    get GET_CODE_NO16() {
        return this.codeNo16;
    }

    /**
     * @Getter
     * codeNo17の取得
     */
    get GET_CODE_NO17() {
        return this.codeNo17;
    }

    /**
     * @Getter
     * codeNo18の取得
     */
    get GET_CODE_NO18() {
        return this.codeNo18;
    }

    /**
     * @Getter
     * codeNo19の取得
     */
    get GET_CODE_NO19() {
        return this.codeNo19;
    }

    /**
     * @Getter
     * codeNo20の取得
     */
    get GET_CODE_NO20() {
        return this.codeNo20;
    }

    // 2022.02.16 jinno 添付ファイル追加対応 start
    /**
     * @Getter
     * codeNo21の取得
     */
      get GET_CODE_NO21() {
        return this.codeNo21;
    }
    /**
     * @Getter
     * codeNo22の取得
     */
      get GET_CODE_NO22() {
        return this.codeNo22;
    }
    /**
     * @Getter
     * codeNo23の取得
     */
      get GET_CODE_NO23() {
        return this.codeNo23;
    }
    /**
     * @Getter
     * codeNo24の取得
     */
      get GET_CODE_NO24() {
        return this.codeNo24;
    }
    /**
     * @Getter
     * codeNo25の取得
     */
      get GET_CODE_NO25() {
        return this.codeNo25;
    }
    /**
     * @Getter
     * codeNo26の取得
     */
      get GET_CODE_NO26() {
        return this.codeNo26;
    }
    /**
     * @Getter
     * codeNo27の取得
     */
      get GET_CODE_NO27() {
        return this.codeNo27;
    }
    /**
     * @Getter
     * codeNo28の取得
     */
      get GET_CODE_NO28() {
        return this.codeNo28;
    }
    /**
     * @Getter
     * codeNo29の取得
     */
      get GET_CODE_NO29() {
        return this.codeNo29;
    }
    /**
     * @Getter
     * codeNo30の取得
     */
      get GET_CODE_NO30() {
        return this.codeNo30;
    }
    // 2022.02.16 jinno 添付ファイル追加対応 end

    /**
     * @Getter
     * ファイルが１つでも格納されていればtrueを返す
     * @returns boolean
     */
    get IS_GET_FILE_UMU() {
        if (this.uploadFile1) {
            if (this.uploadFile1.name) {
                return true;
            }
        }
        if (this.uploadFile2) {
            if (this.uploadFile2.name) {
                return true;
            }
        }
        if (this.uploadFile3) {
            if (this.uploadFile3.name) {
                return true;
            }
        }
        if (this.uploadFile4) {
            if (this.uploadFile4.name) {
                return true;
            }
        }
        if (this.uploadFile5) {
            if (this.uploadFile5.name) {
                return true;
            }
        }
        if (this.uploadFile6) {
            if (this.uploadFile6.name) {
                return true;
            }
        }
        if (this.uploadFile7) {
            if (this.uploadFile7.name) {
                return true;
            }
        }
        if (this.uploadFile8) {
            if (this.uploadFile8.name) {
                return true;
            }
        }
        if (this.uploadFile9) {
            if (this.uploadFile9.name) {
                return true;
            }
        }
        if (this.uploadFile10) {
            if (this.uploadFile10.name) {
                return true;
            }
        }
        if (this.uploadFile11) {
            if (this.uploadFile11.name) {
                return true;
            }
        }
        if (this.uploadFile12) {
            if (this.uploadFile12.name) {
                return true;
            }
        }
        if (this.uploadFile13) {
            if (this.uploadFile13.name) {
                return true;
            }
        }
        if (this.uploadFile14) {
            if (this.uploadFile14.name) {
                return true;
            }
        }
        if (this.uploadFile15) {
            if (this.uploadFile15.name) {
                return true;
            }
        }
        if (this.uploadFile16) {
            if (this.uploadFile16.name) {
                return true;
            }
        }
        if (this.uploadFile17) {
            if (this.uploadFile17.name) {
                return true;
            }
        }
        if (this.uploadFile18) {
            if (this.uploadFile18.name) {
                return true;
            }
        }
        if (this.uploadFile19) {
            if (this.uploadFile19.name) {
                return true;
            }
        }
        if (this.uploadFile20) {
            if (this.uploadFile20.name) {
                return true;
            }
        }
        // 2022.02.16 jinno 添付ファイル追加対応 start
        if (this.uploadFile21) {
            if (this.uploadFile21.name) {
                return true;
            }
        }
        if (this.uploadFile22) {
            if (this.uploadFile22.name) {
                return true;
            }
        }
        if (this.uploadFile23) {
            if (this.uploadFile23.name) {
                return true;
            }
        }
        if (this.uploadFile24) {
            if (this.uploadFile24.name) {
                return true;
            }
        }
        if (this.uploadFile25) {
            if (this.uploadFile25.name) {
                return true;
            }
        }
        if (this.uploadFile26) {
            if (this.uploadFile26.name) {
                return true;
            }
        }
        if (this.uploadFile27) {
            if (this.uploadFile27.name) {
                return true;
            }
        }
        if (this.uploadFile28) {
            if (this.uploadFile28.name) {
                return true;
            }
        }
        if (this.uploadFile29) {
            if (this.uploadFile29.name) {
                return true;
            }
        }
        if (this.uploadFile30) {
            if (this.uploadFile30.name) {
                return true;
            }
        }
        // 2022.02.16 jinno 添付ファイル追加対応 end
        return false;
    }

    // action
    /**
     * @Action
     * アップロードファイルデータ1の保管
     * @param data
     */
    @Action({})
    public setUploadFile1(data: any) {
        this.SET_UPLOAD_FILE1(data);
    }

    /**
     * @Action
     * アップロードファイルデータ2の保管
     * @param data
     */
    @Action({})
    public setUploadFile2(data: any) {
        this.SET_UPLOAD_FILE2(data);
    }

    /**
     * @Action
     * アップロードファイルデータ3の保管
     * @param data
     */
    @Action({})
    public setUploadFile3(data: any) {
        this.SET_UPLOAD_FILE3(data);
    }

    /**
     * @Action
     * アップロードファイルデータ4の保管
     * @param data
     */
    @Action({})
    public setUploadFile4(data: any) {
        this.SET_UPLOAD_FILE4(data);
    }

    /**
     * @Action
     * アップロードファイルデータ5の保管
     * @param data
     */
    @Action({})
    public setUploadFile5(data: any) {
        this.SET_UPLOAD_FILE5(data);
    }

    /**
     * @Action
     * アップロードファイルデータ6の保管
     * @param data
     */
    @Action({})
    public setUploadFile6(data: any) {
        this.SET_UPLOAD_FILE6(data);
    }

    /**
     * @Action
     * アップロードファイルデータ7の保管
     * @param data
     */
    @Action({})
    public setUploadFile7(data: any) {
        this.SET_UPLOAD_FILE7(data);
    }

    /**
     * @Action
     * アップロードファイルデータ8の保管
     * @param data
     */
    @Action({})
    public setUploadFile8(data: any) {
        this.SET_UPLOAD_FILE8(data);
    }

    /**
     * @Action
     * アップロードファイルデータ9の保管
     * @param data
     */
    @Action({})
    public setUploadFile9(data: any) {
        this.SET_UPLOAD_FILE9(data);
    }

    /**
     * @Action
     * アップロードファイルデータ10の保管
     * @param data
     */
    @Action({})
    public setUploadFile10(data: any) {
        this.SET_UPLOAD_FILE10(data);
    }

    /**
     * @Action
     * アップロードファイルデータ11の保管
     * @param data
     */
    @Action({})
    public setUploadFile11(data: any) {
        this.SET_UPLOAD_FILE11(data);
    }

    /**
     * @Action
     * アップロードファイルデータ12の保管
     * @param data
     */
    @Action({})
    public setUploadFile12(data: any) {
        this.SET_UPLOAD_FILE12(data);
    }

    /**
     * @Action
     * アップロードファイルデータ13の保管
     * @param data
     */
    @Action({})
    public setUploadFile13(data: any) {
        this.SET_UPLOAD_FILE13(data);
    }

    /**
     * @Action
     * アップロードファイルデータ14の保管
     * @param data
     */
    @Action({})
    public setUploadFile14(data: any) {
        this.SET_UPLOAD_FILE14(data);
    }

    /**
     * @Action
     * アップロードファイルデータ15の保管
     * @param data
     */
    @Action({})
    public setUploadFile15(data: any) {
        this.SET_UPLOAD_FILE15(data);
    }

    /**
     * @Action
     * アップロードファイルデータ16の保管
     * @param data
     */
    @Action({})
    public setUploadFile16(data: any) {
        this.SET_UPLOAD_FILE16(data);
    }

    /**
     * @Action
     * アップロードファイルデータ17の保管
     * @param data
     */
    @Action({})
    public setUploadFile17(data: any) {
        this.SET_UPLOAD_FILE17(data);
    }

    /**
     * @Action
     * アップロードファイルデータ18の保管
     * @param data
     */
    @Action({})
    public setUploadFile18(data: any) {
        this.SET_UPLOAD_FILE18(data);
    }

    /**
     * @Action
     * アップロードファイルデータ19の保管
     * @param data
     */
    @Action({})
    public setUploadFile19(data: any) {
        this.SET_UPLOAD_FILE19(data);
    }

    /**
     * @Action
     * アップロードファイルデータ20の保管
     * @param data
     */
    @Action({})
    public setUploadFile20(data: any) {
        this.SET_UPLOAD_FILE20(data);
    }

    // 2022.02.16 jinno 添付ファイル追加対応 start
    /**
     * @Action
     * アップロードファイルデータ21の保管
     * @param data
     */
     @Action({})
     public setUploadFile21(data: any) {
         this.SET_UPLOAD_FILE21(data);
     }
     /**
      * @Action
      * アップロードファイルデータ22の保管
      * @param data
      */
     @Action({})
     public setUploadFile22(data: any) {
         this.SET_UPLOAD_FILE22(data);
     }

     /**
      * @Action
      * アップロードファイルデータ23の保管
      * @param data
      */
     @Action({})
     public setUploadFile23(data: any) {
         this.SET_UPLOAD_FILE23(data);
     }

     /**
      * @Action
      * アップロードファイルデータ24の保管
      * @param data
      */
     @Action({})
     public setUploadFile24(data: any) {
         this.SET_UPLOAD_FILE24(data);
     }

     /**
      * @Action
      * アップロードファイルデータ25の保管
      * @param data
      */
     @Action({})
     public setUploadFile25(data: any) {
         this.SET_UPLOAD_FILE25(data);
     }

     /**
      * @Action
      * アップロードファイルデータ26の保管
      * @param data
      */
     @Action({})
     public setUploadFile26(data: any) {
         this.SET_UPLOAD_FILE26(data);
     }

     /**
      * @Action
      * アップロードファイルデータ27の保管
      * @param data
      */
     @Action({})
     public setUploadFile27(data: any) {
         this.SET_UPLOAD_FILE27(data);
     }

     /**
      * @Action
      * アップロードファイルデータ28の保管
      * @param data
      */
     @Action({})
     public setUploadFile28(data: any) {
         this.SET_UPLOAD_FILE28(data);
     }

     /**
      * @Action
      * アップロードファイルデータ29の保管
      * @param data
      */
     @Action({})
     public setUploadFile29(data: any) {
         this.SET_UPLOAD_FILE29(data);
     }

     /**
      * @Action
      * アップロードファイルデータ20の保管
      * @param data
      */
     @Action({})
     public setUploadFile30(data: any) {
         this.SET_UPLOAD_FILE30(data);
     }
    // 2022.02.16 jinno 添付ファイル追加対応 end

    /**
     * @Action
     * アップロードファイルデータ1の保管
     * @param value
     */
    @Action({})
    public setCodeNo1(value: any) {
        this.SET_CODE_NO1(value);
    }

    /**
     * @Action
     * アップロードファイルデータ2の保管
     * @param value
     */
    @Action({})
    public setCodeNo2(value: any) {
        this.SET_CODE_NO2(value);
    }

    /**
     * @Action
     * アップロードファイルデータ3の保管
     * @param value
     */
    @Action({})
    public setCodeNo3(value: any) {
        this.SET_CODE_NO3(value);
    }

    /**
     * @Action
     * アップロードファイルデータ4の保管
     * @param value
     */
    @Action({})
    public setCodeNo4(value: any) {
        this.SET_CODE_NO4(value);
    }

    /**
     * @Action
     * アップロードファイルデータ5の保管
     * @param value
     */
    @Action({})
    public setCodeNo5(value: any) {
        this.SET_CODE_NO5(value);
    }

    /**
     * @Action
     * アップロードファイルデータ6の保管
     * @param value
     */
    @Action({})
    public setCodeNo6(value: any) {
        this.SET_CODE_NO6(value);
    }

    /**
     * @Action
     * アップロードファイルデータ7の保管
     * @param value
     */
    @Action({})
    public setCodeNo7(value: any) {
        this.SET_CODE_NO7(value);
    }

    /**
     * @Action
     * アップロードファイルデータ8の保管
     * @param value
     */
    @Action({})
    public setCodeNo8(value: any) {
        this.SET_CODE_NO8(value);
    }

    /**
     * @Action
     * アップロードファイルデータ9の保管
     * @param value
     */
    @Action({})
    public setCodeNo9(value: any) {
        this.SET_CODE_NO9(value);
    }

    /**
     * @Action
     * アップロードファイルデータ10の保管
     * @param value
     */
    @Action({})
    public setCodeNo10(value: any) {
        this.SET_CODE_NO10(value);
    }

    /**
     * @Action
     * アップロードファイルデータ11の保管
     * @param value
     */
    @Action({})
    public setCodeNo11(value: any) {
        this.SET_CODE_NO11(value);
    }

    /**
     * @Action
     * アップロードファイルデータ12の保管
     * @param value
     */
    @Action({})
    public setCodeNo12(value: any) {
        this.SET_CODE_NO12(value);
    }

    /**
     * @Action
     * アップロードファイルデータ13の保管
     * @param value
     */
    @Action({})
    public setCodeNo13(value: any) {
        this.SET_CODE_NO13(value);
    }

    /**
     * @Action
     * アップロードファイルデータ14の保管
     * @param value
     */
    @Action({})
    public setCodeNo14(value: any) {
        this.SET_CODE_NO14(value);
    }

    /**
     * @Action
     * アップロードファイルデータ15の保管
     * @param value
     */
    @Action({})
    public setCodeNo15(value: any) {
        this.SET_CODE_NO15(value);
    }

    /**
     * @Action
     * アップロードファイルデータ16の保管
     * @param value
     */
    @Action({})
    public setCodeNo16(value: any) {
        this.SET_CODE_NO16(value);
    }

    /**
     * @Action
     * アップロードファイルデータ17の保管
     * @param value
     */
    @Action({})
    public setCodeNo17(value: any) {
        this.SET_CODE_NO17(value);
    }

    /**
     * @Action
     * アップロードファイルデータ18の保管
     * @param value
     */
    @Action({})
    public setCodeNo18(value: any) {
        this.SET_CODE_NO18(value);
    }

    /**
     * @Action
     * アップロードファイルデータ19の保管
     * @param value
     */
    @Action({})
    public setCodeNo19(value: any) {
        this.SET_CODE_NO19(value);
    }

    /**
     * @Action
     * アップロードファイルデータ20の保管
     * @param value
     */
    @Action({})
    public setCodeNo20(value: any) {
        this.SET_CODE_NO20(value);
    }

    // 2022.02.16 jinno 添付ファイル追加対応 start
    /**
     * @Action
     * アップロードファイルデータ21の保管
     * @param value
     */
   @Action({})
   public setCodeNo21(value: any) {
       this.SET_CODE_NO21(value);
   }

   /**
    * @Action
    * アップロードファイルデータ22の保管
    * @param value
    */
   @Action({})
   public setCodeNo22(value: any) {
       this.SET_CODE_NO22(value);
   }

   /**
    * @Action
    * アップロードファイルデータ23の保管
    * @param value
    */
   @Action({})
   public setCodeNo23(value: any) {
       this.SET_CODE_NO23(value);
   }

   /**
    * @Action
    * アップロードファイルデータ24の保管
    * @param value
    */
   @Action({})
   public setCodeNo24(value: any) {
       this.SET_CODE_NO24(value);
   }

   /**
    * @Action
    * アップロードファイルデータ25の保管
    * @param value
    */
   @Action({})
   public setCodeNo25(value: any) {
       this.SET_CODE_NO25(value);
   }

   /**
    * @Action
    * アップロードファイルデータ26の保管
    * @param value
    */
   @Action({})
   public setCodeNo26(value: any) {
       this.SET_CODE_NO26(value);
   }

   /**
    * @Action
    * アップロードファイルデータ27の保管
    * @param value
    */
   @Action({})
   public setCodeNo27(value: any) {
       this.SET_CODE_NO27(value);
   }

   /**
    * @Action
    * アップロードファイルデータ28の保管
    * @param value
    */
   @Action({})
   public setCodeNo28(value: any) {
       this.SET_CODE_NO28(value);
   }

   /**
    * @Action
    * アップロードファイルデータ29の保管
    * @param value
    */
   @Action({})
   public setCodeNo29(value: any) {
       this.SET_CODE_NO29(value);
   }

   /**
    * @Action
    * アップロードファイルデータ30の保管
    * @param value
    */
   @Action({})
   public setCodeNo30(value: any) {
       this.SET_CODE_NO30(value);
   }
    // 2022.02.16 jinno 添付ファイル追加対応 end

    @Action({})
    public moduleReset() {
        this.MODULE_RESET();
    }

    // mutation
    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_UPLOAD_FILE1(data: any) {
        this.uploadFile1 = data;
    }

    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_UPLOAD_FILE2(data: any) {
        this.uploadFile2 = data;
    }

    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_UPLOAD_FILE3(data: any) {
        this.uploadFile3 = data;
    }

    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_UPLOAD_FILE4(data: any) {
        this.uploadFile4 = data;
    }

    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_UPLOAD_FILE5(data: any) {
        this.uploadFile5 = data;
    }

    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_UPLOAD_FILE6(data: any) {
        this.uploadFile6 = data;
    }

    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_UPLOAD_FILE7(data: any) {
        this.uploadFile7 = data;
    }

    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_UPLOAD_FILE8(data: any) {
        this.uploadFile8 = data;
    }

    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_UPLOAD_FILE9(data: any) {
        this.uploadFile9 = data;
    }

    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_UPLOAD_FILE10(data: any) {
        this.uploadFile10 = data;
    }

    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_UPLOAD_FILE11(data: any) {
        this.uploadFile11 = data;
    }

    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_UPLOAD_FILE12(data: any) {
        this.uploadFile12 = data;
    }

    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_UPLOAD_FILE13(data: any) {
        this.uploadFile13 = data;
    }

    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_UPLOAD_FILE14(data: any) {
        this.uploadFile14 = data;
    }

    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_UPLOAD_FILE15(data: any) {
        this.uploadFile15 = data;
    }

    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_UPLOAD_FILE16(data: any) {
        this.uploadFile16 = data;
    }

    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_UPLOAD_FILE17(data: any) {
        this.uploadFile17 = data;
    }

    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_UPLOAD_FILE18(data: any) {
        this.uploadFile18 = data;
    }

    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_UPLOAD_FILE19(data: any) {
        this.uploadFile19 = data;
    }

    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_UPLOAD_FILE20(data: any) {
        this.uploadFile20 = data;
    }
    // 2022.02.16 jinno 添付ファイル追加対応 start
    /**
     * @Mutation
     * @param data
     */
     @Mutation
     private SET_UPLOAD_FILE21(data: any) {
         this.uploadFile21 = data;
     }

     /**
      * @Mutation
      * @param data
      */
     @Mutation
     private SET_UPLOAD_FILE22(data: any) {
         this.uploadFile22 = data;
     }

     /**
      * @Mutation
      * @param data
      */
     @Mutation
     private SET_UPLOAD_FILE23(data: any) {
         this.uploadFile23 = data;
     }

     /**
      * @Mutation
      * @param data
      */
     @Mutation
     private SET_UPLOAD_FILE24(data: any) {
         this.uploadFile24 = data;
     }

     /**
      * @Mutation
      * @param data
      */
     @Mutation
     private SET_UPLOAD_FILE25(data: any) {
         this.uploadFile25 = data;
     }

     /**
      * @Mutation
      * @param data
      */
     @Mutation
     private SET_UPLOAD_FILE26(data: any) {
         this.uploadFile26 = data;
     }

     /**
      * @Mutation
      * @param data
      */
     @Mutation
     private SET_UPLOAD_FILE27(data: any) {
         this.uploadFile27 = data;
     }

     /**
      * @Mutation
      * @param data
      */
     @Mutation
     private SET_UPLOAD_FILE28(data: any) {
         this.uploadFile28 = data;
     }

     /**
      * @Mutation
      * @param data
      */
     @Mutation
     private SET_UPLOAD_FILE29(data: any) {
         this.uploadFile29 = data;
     }

     /**
      * @Mutation
      * @param data
      */
     @Mutation
     private SET_UPLOAD_FILE30(data: any) {
         this.uploadFile30 = data;
     }
    // 2022.02.16 jinno 添付ファイル追加対応 end

    /**
     * @Mutation
     * @param value
     */
    @Mutation
    private SET_CODE_NO1(value: any) {
        this.codeNo1 = value;
    }

    /**
     * @Mutation
     * @param value
     */
    @Mutation
    private SET_CODE_NO2(value: any) {
        this.codeNo2 = value;
    }

    /**
     * @Mutation
     * @param value
     */
    @Mutation
    private SET_CODE_NO3(value: any) {
        this.codeNo3 = value;
    }

    /**
     * @Mutation
     * @param value
     */
    @Mutation
    private SET_CODE_NO4(value: any) {
        this.codeNo4 = value;
    }

    /**
     * @Mutation
     * @param value
     */
    @Mutation
    private SET_CODE_NO5(value: any) {
        this.codeNo5 = value;
    }

    /**
     * @Mutation
     * @param value
     */
    @Mutation
    private SET_CODE_NO6(value: any) {
        this.codeNo6 = value;
    }

    /**
     * @Mutation
     * @param value
     */
    @Mutation
    private SET_CODE_NO7(value: any) {
        this.codeNo7 = value;
    }

    /**
     * @Mutation
     * @param value
     */
    @Mutation
    private SET_CODE_NO8(value: any) {
        this.codeNo8 = value;
    }

    /**
     * @Mutation
     * @param value
     */
    @Mutation
    private SET_CODE_NO9(value: any) {
        this.codeNo9 = value;
    }

    /**
     * @Mutation
     * @param value
     */
    @Mutation
    private SET_CODE_NO10(value: any) {
        this.codeNo10 = value;
    }

    /**
     * @Mutation
     * @param value
     */
    @Mutation
    private SET_CODE_NO11(value: any) {
        this.codeNo11 = value;
    }

    /**
     * @Mutation
     * @param value
     */
    @Mutation
    private SET_CODE_NO12(value: any) {
        this.codeNo12 = value;
    }

    /**
     * @Mutation
     * @param value
     */
    @Mutation
    private SET_CODE_NO13(value: any) {
        this.codeNo13 = value;
    }

    /**
     * @Mutation
     * @param value
     */
    @Mutation
    private SET_CODE_NO14(value: any) {
        this.codeNo14 = value;
    }

    /**
     * @Mutation
     * @param value
     */
    @Mutation
    private SET_CODE_NO15(value: any) {
        this.codeNo15 = value;
    }

    /**
     * @Mutation
     * @param value
     */
    @Mutation
    private SET_CODE_NO16(value: any) {
        this.codeNo16 = value;
    }

    /**
     * @Mutation
     * @param value
     */
    @Mutation
    private SET_CODE_NO17(value: any) {
        this.codeNo17 = value;
    }

    /**
     * @Mutation
     * @param value
     */
    @Mutation
    private SET_CODE_NO18(value: any) {
        this.codeNo18 = value;
    }

    /**
     * @Mutation
     * @param value
     */
    @Mutation
    private SET_CODE_NO19(value: any) {
        this.codeNo19 = value;
    }

    /**
     * @Mutation
     * @param value
     */
    @Mutation
    private SET_CODE_NO20(value: any) {
        this.codeNo20 = value;
    }

    // 2022.02.16 jinno 添付ファイル追加対応 start
    /**
     * @Mutation
     * @param value
     */
     @Mutation
     private SET_CODE_NO21(value: any) {
         this.codeNo21 = value;
     }

     /**
      * @Mutation
      * @param value
      */
     @Mutation
     private SET_CODE_NO22(value: any) {
         this.codeNo22 = value;
     }

     /**
      * @Mutation
      * @param value
      */
     @Mutation
     private SET_CODE_NO23(value: any) {
         this.codeNo23 = value;
     }

     /**
      * @Mutation
      * @param value
      */
     @Mutation
     private SET_CODE_NO24(value: any) {
         this.codeNo24 = value;
     }

     /**
      * @Mutation
      * @param value
      */
     @Mutation
     private SET_CODE_NO25(value: any) {
         this.codeNo25 = value;
     }

     /**
      * @Mutation
      * @param value
      */
     @Mutation
     private SET_CODE_NO26(value: any) {
         this.codeNo26 = value;
     }

     /**
      * @Mutation
      * @param value
      */
     @Mutation
     private SET_CODE_NO27(value: any) {
         this.codeNo27 = value;
     }

     /**
      * @Mutation
      * @param value
      */
     @Mutation
     private SET_CODE_NO28(value: any) {
         this.codeNo28 = value;
     }

     /**
      * @Mutation
      * @param value
      */
     @Mutation
     private SET_CODE_NO29(value: any) {
         this.codeNo29 = value;
     }

     /**
      * @Mutation
      * @param value
      */
     @Mutation
     private SET_CODE_NO30(value: any) {
         this.codeNo30 = value;
     }
    // 2022.02.16 jinno 添付ファイル追加対応 end

    @Mutation
    private MODULE_RESET() {
        this.uploadFile1 = '';
        this.uploadFile2 = '';
        this.uploadFile3 = '';
        this.uploadFile4 = '';
        this.uploadFile5 = '';
        this.uploadFile6 = '';
        this.uploadFile7 = '';
        this.uploadFile8 = '';
        this.uploadFile9 = '';
        this.uploadFile10 = '';
        this.uploadFile11 = '';
        this.uploadFile12 = '';
        this.uploadFile13 = '';
        this.uploadFile14 = '';
        this.uploadFile15 = '';
        this.uploadFile16 = '';
        this.uploadFile17 = '';
        this.uploadFile18 = '';
        this.uploadFile19 = '';
        this.uploadFile20 = '';
        // 2022.02.16 jinno 添付ファイル追加対応 start
        this.uploadFile21 = '';
        this.uploadFile22 = '';
        this.uploadFile23 = '';
        this.uploadFile24 = '';
        this.uploadFile25 = '';
        this.uploadFile26 = '';
        this.uploadFile27 = '';
        this.uploadFile28 = '';
        this.uploadFile29 = '';
        this.uploadFile30 = '';
        // 2022.02.16 jinno 添付ファイル追加対応 end
        this.codeNo1 = '';
        this.codeNo2 = '';
        this.codeNo3 = '';
        this.codeNo4 = '';
        this.codeNo5 = '';
        this.codeNo6 = '';
        this.codeNo7 = '';
        this.codeNo8 = '';
        this.codeNo9 = '';
        this.codeNo10 = '';
        this.codeNo11 = '';
        this.codeNo12 = '';
        this.codeNo13 = '';
        this.codeNo14 = '';
        this.codeNo15 = '';
        this.codeNo16 = '';
        this.codeNo17 = '';
        this.codeNo18 = '';
        this.codeNo19 = '';
        this.codeNo20 = '';
        // 2022.02.16 jinno 添付ファイル追加対応 start
        this.codeNo21 = '';
        this.codeNo22 = '';
        this.codeNo23 = '';
        this.codeNo24 = '';
        this.codeNo25 = '';
        this.codeNo26 = '';
        this.codeNo27 = '';
        this.codeNo28 = '';
        this.codeNo29 = '';
        this.codeNo30 = '';
        // 2022.02.16 jinno 添付ファイル追加対応 end

    }
}

export const fileUploadModule = getModule(FileUpload);
